import { Base } from '@studiometa/js-toolkit';
import { tween, lerp, easeInOutExpo } from '@studiometa/js-toolkit/utils';

/**
 * AncorScrollTo class.
 */
export default class AnchorScrollTo extends Base {
  static config = {
    name: 'AnchorScrollTo',
    options: {
      offset: {
        type: Number,
        default: 0,
      },
      duration: {
        type: Number,
        default: 2,
      },
    },
  };

  /**
   * Get the target element.
   * @returns {HTMLElement}
   */
  get targetElement() {
    return document.querySelector(this.$el.hash);
  }

  /**
   * Get the scroll value of the target.
   * @returns {number}
   */
  get scrollTarget() {
    if (!this.targetElement) {
      return window.scrollY;
    }

    const sizes = this.targetElement.getBoundingClientRect();
    const scrollMargin = getComputedStyle(this.targetElement).scrollMarginTop || '0';
    const max = this.$services.get('scrolled').max.y;
    const scrollTarget =
      sizes.top + window.scrollY - Number.parseInt(scrollMargin, 10) - this.$options.offset;

    // Make sure to not scroll more than the max scroll allowed
    if (scrollTarget > max) {
      return max;
    }

    return scrollTarget;
  }

  /**
   * Scroll to the target selector on click.
   * @param {MouseEvent} event Event
   * @returns {void}
   */
  onClick(event) {
    if (!this.targetElement) {
      return;
    }

    event.preventDefault();

    let tw = null;

    const eventHandler = () => {
      tw.pause();

      window.removeEventListener('wheel', eventHandler);
      window.removeEventListener('touchmove', eventHandler);
    };

    tw = tween(
      (progress) => {
        window.scrollTo(0, lerp(window.scrollY, this.scrollTarget, progress));
      },
      {
        duration: this.$options.duration,
        easing: easeInOutExpo,
        onFinish() {
          window.removeEventListener('wheel', eventHandler);
          window.removeEventListener('touchmove', eventHandler);
        },
      },
    );

    window.addEventListener('wheel', eventHandler, { passive: true });
    window.addEventListener('touchmove', eventHandler, { passive: true });

    tw.start();
  }
}
